import React, { useState, useEffect } from "react"
import SbEditable from "storyblok-react"
import { StaticQuery, graphql } from "gatsby"
import queryString from "query-string"
import countryTelephoneCode from "country-telephone-code"
import { StoryblokFormField } from "../StoryblokFormField"
import {
  cookiePrefill,
  initialFields,
  extractUniversityInfo,
  extractSchoolInfo,
} from "../utils/index"
import {
  addCookieData,
  addNewCookieData,
  addCookieDataSA3,
} from "../../../helpers/handleCookies"
import { useAppContext } from "../../../helpers/appContext"
import ButtonV2 from "../../button-v2"
import styled from "styled-components"

function salesforcePrefill(f, contact) {
  if (f.name === "firstName") {
    if (contact.FirstName) return contact.FirstName
  } else if (f.name === "lastName") {
    if (contact.LastName) return contact.LastName
  } else if (f.type === "email") {
    if (contact.Email) return contact.Email
  } else if (f.name === "countryCode") {
    if (contact.countryCode) return contact.countryCode
  } else if (f.name === "stateCode") {
    if (contact.State) return contact.State
  } else {
    return ""
  }
}

function dispatchDlEvents(name, formId, fields, dispatch, state) {
  let updatedCatalog = { ...state.catalogInfo.Form }

  if (state.catalogInfo.Campus.id) {
    updatedCatalog.relatedCatalogObjects = {
      ...updatedCatalog.relatedCatalogObjects,
      Campus: [state.catalogInfo.Campus.id],
    }
  }

  if (state.catalogInfo.Degree.id) {
    updatedCatalog.relatedCatalogObjects = {
      ...updatedCatalog.relatedCatalogObjects,
      Degree: [state.catalogInfo.Degree.id],
    }
  }

  if (state.catalogInfo.Program.id) {
    updatedCatalog.relatedCatalogObjects = {
      ...updatedCatalog.relatedCatalogObjects,
      Program: [state.catalogInfo.Program.id],
    }
  }

  if (state.catalogInfo.Video.id) {
    updatedCatalog.relatedCatalogObjects = {
      ...updatedCatalog.relatedCatalogObjects,
      Video: [state.catalogInfo.Video.id],
    }
  }

  if (state.catalogInfo.Tags) {
    updatedCatalog.relatedCatalogObjects = {
      ...updatedCatalog.relatedCatalogObjects,
      Tags: state.catalogInfo.Tags,
    }
  }

  dispatch({
    type: "UPDATE_PAGE_INFO",
    payload: {
      catalog: {
        Form: updatedCatalog,
      },
    },
  })
}

function prefillFormFields(fields, contact, blok) {
  const parsedFields = []

  fields.forEach((f) => {
    let prefill = undefined

    prefill = salesforcePrefill(f, contact)
    if (!prefill && f.cookie) {
      prefill = cookiePrefill(f.cookie)
    }

    if (!prefill && f.default) {
      prefill = f.default
    }

    const isValid = prefill ? true : null

    const field = {
      ...f,
      id: f._uid,
      value: prefill,
      valid: isValid,
      default: prefill,
    }

    /* Required field and no prefill from cookie or salesforce, so ensure its not hidden */
    if (f.required && !prefill) {
      field.hidden = false
    }

    if (f.dependant_field) {
      field.hidden = true
    }

    // If field type telephone add additional properties
    if (f.type === "tel") {
      const countryCookie = cookiePrefill("uCountry")
      if (countryCookie) {
        field.countryCode = `+${countryTelephoneCode(countryCookie)}`
        field.isoCountry = countryCookie
      } else {
        field.countryCode = "+1"
        field.isoCountry = "US"
      }
    }

    const originalBlokRequired = blok.fields.filter((obj) => {
      return obj._uid === field._uid
    })

    if (field.dependant_field) {
      const dep = parsedFields.find((d) => d.name === field.dependant_field)
      let feVal
      if (dep) {
        feVal = dep.type === "tel" ? dep.isoCountry : dep.value
      }

      if (
        feVal === field.dependant_value ||
        feVal === true ||
        (field.dependant_value &&
          feVal.length > 0 &&
          field.dependant_value.includes(",") &&
          field.dependant_value.includes(feVal.toLowerCase()))
      ) {
        field.hidden = false
        field.required =
          originalBlokRequired.length > 0 && originalBlokRequired[0].required
      } else {
        field.hidden = true
        field.required = false
      }
    }

    parsedFields.push(field)
  })

  return parsedFields
}

export const GenericForm = ({
  isDark,
  blok,
  redirects,
  name,
  formType,
  formId,
}) => {
  const [contact, setContact] = useState({})
  const [fields, setFields] = useState(
    initialFields(blok.fields, blok?.privacy, blok?.termsAndConditions)
  )
  const [startedForm, setStartedForm] = useState(false)
  const form_implementation = "storyblok"
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const { state, dispatch } = useAppContext()

  useEffect(() => {
    let dl_fields = [
      {
        field_name: "",
        field_type: "",
        field_hidden: false,
      },
    ]

    fields.forEach((f) => {
      dl_fields.push({
        field_name: f.name,
        field_type: f.type,
        field_hidden: f.hidden,
      })
    })

    if (typeof window !== "undefined") {
      dispatch({
        type: "UPDATE_CATALOG_INFO",
        payload: {
          Form: {
            id: formId && formId,
            name: name && name.replace(/-/g, " "),
            url: window.location.href,
            attributes: dl_fields,
          },
        },
      })
    }
  }, [])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S

      window.dataLayer.push({
        event: "form_view",
        eventMeta: {
          form_platform: form_implementation,
          form_type: formType,
        },
      })

      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            setContact(JSON.parse(data))
            setFields(prefillFormFields(fields, JSON.parse(data), blok))
          })
      } else {
        setContact({})
        setFields(prefillFormFields(fields, contact, blok))
      }
    }
  }, [])

  function handleValueChange(id, obj) {
    let fe = [...fields]

    // Find field and set value/valid properties
    const idx = fe.findIndex((el) => el.id === id)
    if (fe[idx].type === "tel") {
      fe[idx].countryCode = obj.countryCode
      fe[idx].isoCountry = obj.isoCountry
    } else if (fe[idx].name === "selectYourProgram") {
      fe[idx].selectLabel = obj.selectLabel
    }

    if (fe[idx].type === "text" || fe[idx].type === "lookup") {
      fe[idx].value = obj.value.replace("'", "’")
    } else {
      fe[idx].value = obj.value
    }

    // If current valid is null it must be true before being invalid
    if (
      (fe[idx].valid === null && obj.valid) ||
      fe[idx].valid ||
      fe[idx].valid === false
    ) {
      fe[idx].valid = obj.valid
    }

    /* Check if it has dependant fields */
    const name = fe[idx].name
    const feVal = fe[idx].type === "tel" ? fe[idx].isoCountry : fe[idx].value

    fe.forEach((f) => {
      const originalBlokRequired = blok.fields.filter((obj) => {
        return obj._uid === f._uid
      })

      const dependant_array = f.dependant_value && f.dependant_value.split(", ")
      if (name === f.dependant_field && feVal) {
        if (
          feVal === f.dependant_value ||
          feVal === true ||
          (f.dependant_value &&
            feVal.length > 0 &&
            f.dependant_value.includes(",") &&
            dependant_array.includes(feVal.toLowerCase()))
        ) {
          f.hidden = false
          f.required =
            originalBlokRequired.length > 0 && originalBlokRequired[0].required
        } else {
          f.hidden = true
          f.required = false
        }
      } else if (name === f.dependant_field && !feVal) {
        f.hidden = true
        f.required = false
      }
    })

    if (!startedForm) {
      window.dataLayer.push({
        event: "form_start",
        eventMeta: {
          form_platform: form_implementation,
          form_type: formType,
        },
      })
      dispatchDlEvents(name, formId, fields, dispatch, state)
      setStartedForm(true)
    }

    setFields(fe)
  }

  function checkValidity() {
    let allValid = true
    let checkedFields = [...fields]

    let invalidFields = []

    checkedFields.forEach((f) => {
      // Mark the fields that are required but not valid
      if (!f.valid && f.required) {
        allValid = false
        f.valid = false
        invalidFields.push(f.name)
      }
    })

    return [allValid, checkedFields, formType, `${invalidFields.join(",")}`]
  }

  async function submitForm() {
    // Construct JSON
    let json = {}
    let brochureSlug = null
    let telIsoCountryCode = null

    fields.forEach((f) => {
      if (f.hidden && f.dependant_value) {
        // If the field is hidden and dependant_value exists, skip processing
        return
      }

      if (f.name === "privacy") {
        // Do not add privacy to json
      } else if (f.name === "comments") {
        // Add label with delimiter
        json[f.name] = `${f.label} : ${f.value}`
      } else if (f.type === "tel") {
        json[f.name] = `${f.countryCode}${f.value}`
        telIsoCountryCode = f.isoCountry
      } else {
        json[f.name] = f.value
      }

      // Trim trailing spaces for firstName and lastName
      if (f.name === "firstName" || f.name === "lastName") {
        json[f.name] = f.value.trim()
      }

      if (
        f.name === blok.fieldLevelDependency &&
        redirects &&
        blok.redirectType === "fieldLevel"
      ) {
        const redirect = redirects.filter(
          (redirect) =>
            redirect?.node?.value.toLowerCase() === f.value.toLowerCase()
        )
        brochureSlug = redirect ? redirect[0]?.node?.name : null
      }
    })

    json["formType"] = formType

    dispatch({
      type: "UPDATE_USER_INFO",
      payload: {
        emailAddress: json.email,
        firstName: json.firstName,
        lastName: json.lastName,
      },
    })

    window.dataLayer.push({
      user: {
        program: json["selectYourProgram"],
      },
    })

    // If we don't have a country field use phone IsoCountry
    if (!json.countryCode && telIsoCountryCode) {
      json.countryCode = telIsoCountryCode
    }

    const universityInfo = extractUniversityInfo(fields)
    const schoolInfo = extractSchoolInfo(fields)

    if (formType === "SA3") {
      setLoading(true)

      fetch(`${process.env.GATSBY_STUDENT_APP_3_MAGIC_LINK}`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          program: json.selectYourProgram,
          campus: json.campus || undefined,
          startTerm: json.startTerm || undefined,
          ...json,
          givenName: json.firstName,
          surname: json.lastName,
          geo_country: json.countryCode,
          universityName: universityInfo.universityName || undefined,
          university: universityInfo.universityId || undefined,
          highSchoolName: schoolInfo.schoolName || undefined,
          highSchool: schoolInfo.schoolId || undefined,
          // geo_state: string;
          // geo_city: string;
          phonenumber: json.phoneNumber,
          ...addCookieDataSA3(),
        }),
      })
        .then((res) => {
          if (res.status === 500) {
            setLoading(false)
            setErrorMessage(
              <p>
                An unknown error has occurred. Please try again or contact your
                enrollment advisor.
              </p>
            )
            throw new Error(`HTTP ${res.status}: Server Error`)
          }
          return res.json()
        })
        .then((body) => {
          const { status, msg } = body
          setLoading(false)
          if (status) {
            if (["error", "failed"].includes(status.toLowerCase())) {
              if (msg === "FAILED") {
                setErrorMessage(
                  <p>Something went wrong. Please try again later.</p>
                )
              }
              if (msg === "DUP") {
                setErrorMessage(
                  <p>
                    This email already has an account associated with it. Try to
                    log in instead.
                  </p>
                )
              } else {
                setErrorMessage(
                  <p>
                    An unknown error has occurred. Please try again or contact
                    your enrollment advisor.
                  </p>
                )
              }

              throw new Error(msg)
            }
          }
          const { link } = body
          if (link) {
            window.location = link
          }
        })
        .catch((err) => {
          setLoading(false)
          console.error({ err })
        })
    } else {
      setLoading(true)

      fetch(`${process.env.GATSBY_INTEGRATION_API}`, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "x-api-key": process.env.GATSBY_INTEGRATION_CONT_API_KEY,
        },
        body: JSON.stringify({
          type: json.formType || undefined,
          program: json.selectYourProgram || undefined,
          firstName: json.firstName || undefined,
          lastName: json.lastName || undefined,
          email: json.email || undefined,
          phone: json.phoneNumber || undefined,
          country: json.countryCode || undefined,
          state: json.state || json.stateCode || undefined,
          city: json.city || undefined,
          address1: json.addressline1 || undefined,
          address2: json.addressline2 || undefined,
          postcode: json.postalcode || undefined,
          universityName: universityInfo.universityName || undefined,
          university: universityInfo.universityId || undefined,
          highSchoolName: schoolInfo.schoolName || undefined,
          highSchool: schoolInfo.schoolId || undefined,
          comments: json.comments || undefined,
          campus: json.campus || undefined,
          startTerm: json.startTerm || undefined,
          linkedin: json.linkedin || undefined,
          subject: json.subject || undefined,
          workExperience: json.workExperience || undefined,
          specialization: json.specialization || undefined,
          jobTitle: json.jobTitle || undefined,
          organisation: json.organisation || undefined,
          Company: json.Company || undefined,
          degreeType: json.degreeType || undefined,
          englishLevel: json.englishLevel || undefined,
          campaignId: json.campaignID || undefined,
          extraPrivacy: json.extraPrivacy || undefined,
          howDidyouHearAboutUs: json.howDidyouHearAboutUs || undefined,
          referralEmail: json.referralEmail || undefined,
          ...addNewCookieData(),
        }),
      })
        .then((res) => {
          if (res.status === 500) {
            setLoading(false)
            setErrorMessage(
              <p>
                An unknown error has occurred. Please try again or{" "}
                <a href="/contact-us/">contact us</a>.
              </p>
            )
            throw new Error(`HTTP ${res.status}: Server Error`)
          }
          return res
        })
        .then(() => {
          // Push submitForm event to GA
          window.dataLayer.push({
            event: "hultedu_submitForm",
            eventMeta: {
              content: json["formType"],
              timestamp: JSON.stringify(new Date()),
            },
          })

          let getProgramValue =
            fields.find((field) => field.name === "selectYourProgram") &&
            fields.find((field) => field.name === "selectYourProgram").value

          window.dataLayer.push({
            event: "form_success",
            eventMeta: {
              form_platform: form_implementation,
              form_type: json["formType"],
              program: getProgramValue || "",
              uniId: universityInfo.universityId || "",
            },
          })

          // Set the redirection within setTimeout to prevent reset of loading
          setTimeout(() => {
            if (blok.redirectType === "formLevel" && blok.formLevelLink) {
              window.location = blok.formLevelLink
            } else if (blok.redirectType === "fieldLevel" && brochureSlug) {
              window.location = brochureSlug
            }
          }, 500) // Short delay to ensure loading state persists momentarily before redirect
        })
        .catch((err) => {
          setLoading(false)
          console.log(err)
        })
    }
  }

  const StyledError = styled.div`
    display: grid;
    grid-column: span 2;
    border: 2px solid #fa5c66;
    padding: 16px;
    border-radius: 4px;
    /* margin-bottom: 8px; */

    & p {
      margin: 0;
      color: #fa5c66;

      a {
        color: #fa5c66;
        text-decoration: underline;
      }
    }
  `

  const StyledErrorTitle = styled.p`
    font-family: ${(props) => props.theme.fonts.circularBold};
    padding-bottom: 8px;
  `

  function handleSubmit() {
    const valid = checkValidity()

    setFields(valid[1])

    let getProgramValue =
      fields.find((field) => field.name === "selectYourProgram") &&
      fields.find((field) => field.name === "selectYourProgram").value

    const form_type = valid[2]

    window.dataLayer.push({
      event: "form_submission",
      eventMeta: {
        form_platform: form_implementation,
        form_type: form_type,
        program: getProgramValue || "",
        uniId: extractUniversityInfo(fields).universityId || "",
      },
    })

    if (valid[0]) {
      submitForm(fields)
    } else {
      // Invalid data, therefore send event to GA
      window.dataLayer.push({
        event: "hultedu_validationError",
        eventMeta: {
          content: `${form_type} - ${valid[3]}`,
          timestamp: JSON.stringify(new Date()),
        },
      })
      window.dataLayer.push({
        event: "form_validation_error",
        eventMeta: {
          form_platform: form_implementation,
          form_type: form_type,
          fields: valid[3],
        },
      })
    }
  }
  return (
    <>
      <StaticQuery
        query={graphql`
          query {
            allStoryblokEntry(filter: { slug: { eq: "global" } }) {
              edges {
                node {
                  content
                }
              }
            }
          }
        `}
        render={(data) => {
          const globalData = JSON.parse(
            data.allStoryblokEntry.edges[0].node.content
          )
          return (
            <SbEditable content={blok}>
              {errorMessage && <StyledError>{errorMessage}</StyledError>}
              {globalData.maintenance_sa3 && formType === "SA3" ? (
                <StyledError>
                  <StyledErrorTitle>
                    Application portal is currently down for scheduled
                    maintenance.
                  </StyledErrorTitle>
                  <p>
                    We expect to be back in a few hours. Thanks for your
                    patience.{" "}
                  </p>
                </StyledError>
              ) : (
                <>
                  {fields &&
                    fields.map((field) => (
                      <StoryblokFormField
                        loading={loading}
                        key={field._uid}
                        isDark={isDark}
                        blok={field}
                        value={field.value}
                        onValueChange={handleValueChange}
                      />
                    ))}
                  <main>
                    <ButtonV2
                      loading={loading}
                      label={blok.buttonLabel}
                      className="button-v2--primary"
                      icon={"ArrowRight"}
                      onClick={handleSubmit}
                      type="submit"
                    />
                  </main>
                </>
              )}
            </SbEditable>
          )
        }}
      />
    </>
  )
}
